import React, { Component } from 'react';
import { connect } from "react-redux";
import {SEQUENCER_VIEW, SOUND_DETAILS_VIEW, MULTI_DETAILS_VIEW} from 'constants/view-modes.js';
import {
    CURRENT_SUB_SEQUENCE_BUTTON,
    NEW_SUB_SEQUENCE_BUTTON,
    DELETE_SUB_SEQUENCE_BUTTON} from 'constants/contextual-help.js';
import Documented from 'components/help/Documented.js';
import {setViewMode} from 'actions/index.js';

const NAMES = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', "J", "K", "L", "M", "N"];

class SubSequencesComponent extends Component {
    chooseSubSequence(id) {
        if (this.props.viewMode === SOUND_DETAILS_VIEW ||
            this.props.viewMode === MULTI_DETAILS_VIEW) {
            this.props.setViewMode(SEQUENCER_VIEW);
        }
    
        this.props.sequencerEngine.switchToSubSequence(id);
    }

    newSubSequence() {
        if (this.props.viewMode === SOUND_DETAILS_VIEW ||
            this.props.viewMode === MULTI_DETAILS_VIEW) {
            this.props.setViewMode(SEQUENCER_VIEW);
        }
    
        this.props.sequencerEngine.newSubSequence();
    }

    deleteSubSequence() {
        if (window.confirm("Are you sure you want to delete this SUB SEQUENCE?")) {
            this.props.sequencerEngine.deleteSubSequence();
        }
    }

    render() {
        return (
            <div className="sub-sequences-container">
              {this.props.subSequences
                  .filter(id => !this.props.sequencerEngine.getSubSequence(id).isTrack)
                  .map(
                  (id, i) =>
                      <Documented
                        element={CURRENT_SUB_SEQUENCE_BUTTON}
                            key={NAMES[i]}
                            onClick={() => this.chooseSubSequence(id)}
                            className={id === this.props.currentSubSequence ?
                                      "sub-sequence selected" : "sub-sequence"}>
                        {NAMES[i]}</Documented>)}
                <Documented
                  element={NEW_SUB_SEQUENCE_BUTTON}
                  onClick={() => this.newSubSequence()}
                  className="new-sub-sequence">+</Documented>
              <Documented
                  element={DELETE_SUB_SEQUENCE_BUTTON}
                onClick={() => this.deleteSubSequence()}
                className="delete-sub-sequence">-</Documented>
            </div>
        );
    }
}
const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.engineId;
    return {
        subSequences: state.sequencer.subSequences[id] || [],
        currentSubSequence: state.sequencer.currentSubSequence[id],
        viewMode: state.sequencer.viewMode,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setViewMode: (x) => dispatch(setViewMode(x))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubSequencesComponent);
 
 
